import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ApartmentDetail from "@/pages/ApartmentDetail";
import Consultancy from "@/pages/Consultancy";
import ScrollToTop from "@/components/ScrollToTop";
import { InquiryProvider } from "@/contexts/InquiryContext";
import InquiryModal from "@/components/InquiryModal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <InquiryProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apartments/:id" element={<ApartmentDetail />} />
            <Route path="/consultancy" element={<Consultancy />} />
          </Routes>
          <InquiryModal />
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              style: {
                fontFamily: "Inter, sans-serif",
                borderRadius: "10px",
              },
            }}
          />
        </InquiryProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
